import { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { sessionService } from 'redux-react-session';

import { isLoggedIn } from './logic/requests/users';

import CookiesPopUp from './components/organisms/CookiesPopUp/CookiesPopUp';
import HelmetTemplate from './components/molecules/HelmetTemplate/HelmetTemplate';

import ScrollToTop from './components/organisms/ScrollToTop/ScrollToTop';
import GlobalStyle from './styles/GlobalStyle';

import GaTracker from './components/GaTracker';
// import UnderConstruction from "./components/pages/UnderConstruction"; // Kiedy produkcja leży :D

import { getString } from './strings';
import { setSessionExpiredHandler } from './logic/requests/sessionExpiredHandler';
import RouterContent from './RouterContent';

const App = () => {
    /*
        TODO: można użyć tego stanu zamiast wczytywać w każdym komponencie
        z osobna, ale wtedy dalej będzie 'null' po zalogowaniu / wylogowaniu
        trzeba by wtedy odświeżyć stronę, albo podać 'set'a do komponentu
        z logowaniem
    */
    const [user, setUser] = useState();
    const [loading, setLoading] = useState(true);
    const [sessionExpiredPopupOpen, setSessionExpiredPopupOpen] = useState(false);

    useEffect(() => {
        const init = async () => {
            let hadSession = false;

            try {
                const storedUser = await sessionService.loadUser().catch(() => null);
                hadSession = !!storedUser && Object.keys(storedUser).length > 0;

                const res = await isLoggedIn();
                const loggedIn = res?.loggedIn ?? false;

                if (loggedIn) {
                    await sessionService.saveUser(res.user);
                    setUser(res.user);
                } else {
                    await sessionService.deleteUser();
                    if (hadSession) {
                        setSessionExpiredPopupOpen(true);
                    }
                }
            } catch (err) {
                if (window.location.pathname === '/' || window.location.pathname === '/login') {
                    await sessionService.deleteUser();
                }
                if (err.status === 401 && hadSession) {
                    setSessionExpiredPopupOpen(true);
                }
            } finally {
                setLoading(false);
            }
        };

        init();
    }, []);

    useEffect(() => {
        setSessionExpiredHandler(async () => {
            await sessionService.deleteSession();
            setSessionExpiredPopupOpen(true);
        });
    }, []);

    // useEffect(() => console.log("App", "user", user), [user]);

    if (loading) return null;

    return (
        <div>
            <HelmetTemplate
                title={getString('seo_home_title')}
                desc={getString('seo_home_desc')}
                ogTitle={getString('seo_home_twitter_title')}
            />
            <GlobalStyle />
            <Router>
                <GaTracker />
                <ScrollToTop />
                <RouterContent
                    sessionExpiredPopupOpen={sessionExpiredPopupOpen}
                    setSessionExpiredPopupOpen={setSessionExpiredPopupOpen}
                />
            </Router>
            <CookiesPopUp />
        </div>
    );
};

export default App;
